import { StyledCaseReportSectionTitle } from 'src/components/atomsLegacy';
import { AdvisoryText } from 'src/components/atomsLegacy/typography/AdvisoryText/AdvisoryText.styles';
import { TitleText as TitleTextStyle } from 'src/components/atomsLegacy/typography/TitleText/TitleText.styles';
import styled from 'styled-components';

export const ReportDetailsContainer = styled.div<{
  isVisible: boolean;
}>`
  position: relative;
  display: flex;
  flex-direction: column;
  max-width: ${(props) => (props.isVisible ? '300px' : 0)};
  min-width: ${(props) => (props.isVisible ? '275px' : '50px')};
  height: 100%;
  border: 1px solid white;
  background: ${(props) => props.theme.newPalette.neutral.N0};
  border-radius: 8px;
  justify-content: flex-start;
`;

export const Title = styled(StyledCaseReportSectionTitle)`
  text-transform: uppercase;
  margin: 10px 0 0;
`;

export const TitleText = styled(TitleTextStyle)`
  margin: 16px 0px 16px 24px;
`;

export const DetailsContainer = styled.div<{
  isVisible: boolean;
}>`
  display: flex;
  flex-direction: column;
  flex-grow: 2;
  gap: 20px;
  padding-left: 24px;
  margin-bottom: 34px;
  visibility: ${(props) => (props.isVisible ? 'visible' : 'hidden')};
`;

export const DetailContainer = styled.div<{ first?: boolean }>`
  display: flex;
  flex-direction: column;
  ${(props) => props.first && 'padding-top: 24px;'};
`;
export const ButtonContainer = styled.div`
  display: grid;
  grid-gap: 12px;
`;

export const TitleContainer = styled.div<{
  isVisible: boolean;
}>`
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  height: 50px;
  border-bottom: 1px solid ${(props) => props.theme.newPalette.neutral.N300};
  visibility: ${(props) => (props.isVisible ? 'visible' : 'hidden')};
`;

export const BottomContainer = styled.div<{
  isVisible: boolean;
}>`
  display: flex;
  flex-direction: column;
  height: 100%;
  align-items: center;
  border-top: 1px solid ${(props) => props.theme.newPalette.neutral.N300};
  visibility: ${(props) => (props.isVisible ? 'visible' : 'hidden')};
`;

export const Text = styled(AdvisoryText)`
  width: auto;
  border: none;
  margin-top: 0;
`;

export const ReportDetailsToggleStyled = styled.div`
  position: absolute;
  top: 18px;
  right: 10px;

  img {
    width: 8px;
    height: 14px;
  }
`;
